import {makeAutoObservable} from "mobx";
import {TableDisplayEnum} from "../entity/enum/home";
import {PageEntity} from "../entity/page-entity";
import {TreeEntity} from "../entity/tree-entity";
import {ImageInfoEntity} from "../entity/image-info-entity";

export class HomeLibraryStore {

    constructor() {
        makeAutoObservable(this)
    }

    public isExpend: boolean = false;
    public condition = this.getDefaultCondition();
    public detailModalOpen: boolean = false;
    public index: number = 0;
    public pagination:PageEntity = new PageEntity();
    public dataSource: ImageInfoEntity[] = []
    public detailEntity!:ImageInfoEntity;

    public setExpend(isExpend:boolean){
        this.isExpend = isExpend;
    }

    public setDataSource(list: ImageInfoEntity[]) {
        this.dataSource = list;
    }

    private getDefaultCondition() {
        return {
            libraryCode: "",
            specimenName: "", // 中文名
            gatherer: "",
            gatherDate: "",
            gatherDateEnd: "",
            gatherDateStart:"",
            gatherNumber:"",
            takeTime:"",
        };
    }

    public resetQuery = () => {
        this.condition = this.getDefaultCondition();
    }

    public setDetail(detail: ImageInfoEntity){
        this.detailEntity = detail;
    }

    public setIndex(index:number){
        this.index = index;
    }

    public setDetailModalOpen(open: boolean) {
        this.detailModalOpen = open;
    }

    public clear() {
        this.isExpend = false;
        this.condition = this.getDefaultCondition();
        this.detailModalOpen = false;
        this.index = 0;
        this.pagination = new PageEntity();

    }
}